"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPurchaseStatusToJSON = exports.NftPurchaseStatusFromJSONTyped = exports.NftPurchaseStatusFromJSON = exports.NftPurchaseStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var NftPurchaseStatus;
(function (NftPurchaseStatus) {
    NftPurchaseStatus["CART"] = "CART";
    NftPurchaseStatus["PAYMENT"] = "PAYMENT";
    NftPurchaseStatus["ERRORPAYMENT"] = "ERROR_PAYMENT";
    NftPurchaseStatus["PROCESSING"] = "PROCESSING";
    NftPurchaseStatus["MINTED"] = "MINTED";
    NftPurchaseStatus["FULLERRORMINTING"] = "FULL_ERROR_MINTING";
    NftPurchaseStatus["PARTIALERRORMINTING"] = "PARTIAL_ERROR_MINTING";
})(NftPurchaseStatus = exports.NftPurchaseStatus || (exports.NftPurchaseStatus = {}));
function NftPurchaseStatusFromJSON(json) {
    return NftPurchaseStatusFromJSONTyped(json, false);
}
exports.NftPurchaseStatusFromJSON = NftPurchaseStatusFromJSON;
function NftPurchaseStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.NftPurchaseStatusFromJSONTyped = NftPurchaseStatusFromJSONTyped;
function NftPurchaseStatusToJSON(value) {
    return value;
}
exports.NftPurchaseStatusToJSON = NftPurchaseStatusToJSON;
